"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const opportunity_service_1 = require("./opportunity.service");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const opportunity_query_param_dto_1 = require("./dto/opportunity-query-param.dto");
const constants_1 = require("../../../../service-lib/src/lib/constants");
const create_opportunity_dto_1 = require("./dto/create-opportunity.dto");
const update_opportunity_dto_1 = require("./dto/update-opportunity.dto");
const opportunity_swagger_1 = require("./opportunity.swagger");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
// import { CreateFinalNegotiationDto } from "./dto/create-final-negotiation.dto";
const opportunity_activity_dto_1 = require("./dto/opportunity-activity.dto");
const create_quote_entry_dto_1 = require("./dto/create-quote-entry.dto");
const update_policy_docket_1 = require("./dto/update-policy-docket");
const update_held_cover_note_dto_1 = require("./dto/update-held-cover-note.dto");
const update_policy_confirmation_dto_1 = require("./dto/update-policy-confirmation.dto");
const scope_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/scope.utils");
const update_placement_slip_dto_1 = require("./dto/update-placement-slip.dto");
const update_policy_hard_copy_dto_1 = require("./dto/update-policy-hard-copy.dto");
const create_opportunity_lost_dto_1 = require("./dto/create-opportunity-lost.dto");
const create_broking_slip_version_dto_1 = require("./dto/create-broking-slip-version.dto");
const update_quote_comparison_report_dto_1 = require("./dto/update-quote-comparison-report.dto");
const generate_quote_comparison_report_dto_1 = require("./dto/generate-quote-comparison-report.dto");
const opportunity_rfp_details_entry_dto_1 = require("./dto/opportunity-rfp-details-entry.dto");
const update_premium_calculation_dto_1 = require("./dto/update-premium-calculation.dto");
let OpportunityController = class OpportunityController {
    constructor(opportunityService, scopeService) {
        this.opportunityService = opportunityService;
        this.scopeService = scopeService;
    }
    // Creates a new opportunity by delegating the service.
    async createOpportunity(createOpportunityDto, opportunityRiskLocations, opportunityClaimExperiences, opportunityDocuments, previousPlacementDetails, opportunityPreviousMediatorDetails, contacts, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            createOpportunityDto.createdBy = userId;
            createOpportunityDto.updatedBy = userId;
            createOpportunityDto.ownerId = userId;
            const opportunity = await this.opportunityService.createOpportunity(createOpportunityDto, opportunityRiskLocations, opportunityClaimExperiences, opportunityDocuments, previousPlacementDetails, opportunityPreviousMediatorDetails, contacts, userId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.CREATED, messages_1.successMessage.opportunityCreated, opportunity);
        }
        catch (error) {
            console.error("Error in getOpportunityActivityMeta:", error);
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error.message);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.opportunityCreationFailed);
        }
    }
    // Retrieves a list of opportunities based on the provided query parameters.
    async getAllOpportunityList(queries, res, req) {
        try {
            const { sort, page, limit, search, searchBy, field, from, to, period } = queries;
            const userId = parseInt(req?.headers?.userid);
            const opportunities = await this.opportunityService.getAllOpportunityList(page || constants_1.DEFAULT_VALUES.PAGE, limit || constants_1.DEFAULT_VALUES.LIMIT, search || "", sort, searchBy, userId, field, from, to || null, period);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.opportunityListRetrieved, opportunities));
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return res
                    .status(common_1.HttpStatus.NOT_FOUND)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error.message));
            }
            return res
                .status(common_1.HttpStatus.BAD_REQUEST)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.opportunityListRetrievalFailed));
        }
    }
    async getQuoteByBrokingSlipAndActivity(brokingSlipId, opportunityActivityId, res) {
        try {
            const quote = await this.opportunityService.getQuoteByBrokingSlipAndActivity(brokingSlipId, opportunityActivityId);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.quoteRetrieved, quote));
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return res
                    .status(common_1.HttpStatus.NOT_FOUND)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error.message));
            }
            return res
                .status(common_1.HttpStatus.BAD_REQUEST)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.quoteRetrievalFailed));
        }
    }
    async getQuotesByBrokingSlip(brokingSlipId, res) {
        try {
            const quotes = await this.opportunityService.getQuotesByBrokingSlip(brokingSlipId);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.quoteRetrieved, quotes));
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return res
                    .status(common_1.HttpStatus.NOT_FOUND)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error.message));
            }
            return res
                .status(common_1.HttpStatus.BAD_REQUEST)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.quoteRetrievalFailed));
        }
    }
    async getQuoteEntryDetails(opportunityActivityId) {
        try {
            const quote = await this.opportunityService.getQuoteEntryDetails(opportunityActivityId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.quoteRetrieved, quote);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error.message);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.quoteRetrievalFailed);
        }
    }
    async getAllPolicies(res) {
        try {
            console.log("Fetching all policies...");
            const policies = await this.opportunityService.getAllPolicies();
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, "Policies retrieved successfully", policies));
        }
        catch (error) {
            console.error("Error in getAllPolicies:", error);
            return res
                .status(common_1.HttpStatus.BAD_REQUEST)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error ? error.message : "Failed to fetch policies."));
        }
    }
    // Retrieves an opportunity by delegating the service using ID.
    async getOpportunityById(opportunityId, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const viewValidation = await this.scopeService.validateResourceScope(userId, "opportunity", "view", opportunityId);
            if (!viewValidation) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.FORBIDDEN, "Access denied: You do not have permission to view this company.");
            }
            const opportunity = await this.opportunityService.getOpportunityById(opportunityId, userId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.opportunityDetails, opportunity);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.opportunityNotFound);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.opportunityDetailsRetrievalFailed);
        }
    }
    async getOpportunitiesByCompanyId(companyId, page, limit) {
        try {
            const opportunities = await this.opportunityService.getOpportunitiesByCompanyId(companyId, page || constants_1.DEFAULT_VALUES.PAGE, limit || constants_1.DEFAULT_VALUES.LIMIT);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.opportunityListRetrieved, opportunities);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.opportunityNotFound);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.opportunityListRetrievalFailed);
        }
    }
    async getQuotesBasedOnOpportunityActivityId(opportunityActivityId, page, limit) {
        try {
            const quotes = await this.opportunityService.getQuotesBasedOnOpportunityActivityId(opportunityActivityId, page || constants_1.DEFAULT_VALUES.PAGE, limit || constants_1.DEFAULT_VALUES.LIMIT);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, "Quotes retrieved successfully", quotes);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, "Quotes not found for the given opportunity activity ID.");
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : "Quotes retrieval failed for the given opportunity activity ID.");
        }
    }
    async getQuoteById(quoteId) {
        try {
            const quote = await this.opportunityService.getQuoteById(quoteId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.quoteRetrieved, quote);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, "Quote not found for the given ID.");
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.quoteRetrievalFailed);
        }
    }
    async getCoverDataPrefill(opportunityActivityId) {
        try {
            const data = await this.opportunityService.getCoverDataPrefill(opportunityActivityId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, "Cover details retrieved successfully", data);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error.message);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : "Cover details retrieval failed");
        }
    }
    // Updates the opportunity activity by delegating the service.
    async updateOpportunityActivity(updateOpportunityActivityData, req, res) {
        try {
            const userId = parseInt(req?.headers?.userid);
            updateOpportunityActivityData.updatedBy = userId;
            const opportunity = await this.opportunityService.updateOpportunityActivity(updateOpportunityActivityData);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.opportunityActivityCreated, opportunity));
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return res
                    .status(common_1.HttpStatus.NOT_FOUND)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error.message));
            }
            return res
                .status(common_1.HttpStatus.BAD_REQUEST)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error?.response?.message?.length > 0
                    ? error?.response?.message
                    : error.message
                : messages_1.errorMessages.opportunityCreationFailed));
        }
    }
    // Updates an existing opportunity by delegating the service using ID.
    async updateOpportunityById(opportunityId, updateOpportunityDto, updateRiskLocations, updateClaimExperiences, updateDocuments, previousPlacementDetails, opportunityPreviousMediatorDetails, contacts, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const editValidation = await this.scopeService.validateResourceScope(userId, "opportunity", "edit", opportunityId);
            if (!editValidation) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.FORBIDDEN, "Access denied: You do not have permission to edit this company.");
            }
            const opportunity = await this.opportunityService.updateOpportunityById(opportunityId, updateOpportunityDto, updateRiskLocations, updateClaimExperiences, updateDocuments, previousPlacementDetails, opportunityPreviousMediatorDetails, contacts, userId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.opportunityUpdated, opportunity);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error.message || messages_1.errorMessages.opportunityNotFound);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.opportunityUpdateFailed);
        }
    }
    // Deletes an opportunity by delegating the service using ID.
    async deleteOpportunityById(opportunityId, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const editValidation = await this.scopeService.validateResourceScope(userId, "opportunity", "edit", opportunityId);
            if (!editValidation) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.FORBIDDEN, "Access denied: You do not have permission to edit this company.");
            }
            await this.opportunityService.deleteOpportunityById(opportunityId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.opportunityDeleted);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.opportunityNotFound);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error
                ? error.message
                : messages_1.errorMessages.opportunityDeletionFailed);
        }
    }
    /**
     * Retrieves the opportunity activities and its participants based on the Opportunity ID.
     */
    async getOpportunityActivityById(opportunityId, req, res) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const viewValidation = await this.scopeService.validateResourceScope(userId, "opportunity", "edit", opportunityId);
            if (!viewValidation) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.FORBIDDEN, "Access denied: You do not have permission to edit this company.");
            }
            const opportunity = await this.opportunityService.getOpportunityActivityById(opportunityId);
            // let owner = null;
            // if (opportunity?.length > 0) {
            //   owner = opportunity[0]?.owner;
            // }
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, "Opportunity Activities retrieved successfully", opportunity));
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return res
                    .status(common_1.HttpStatus.NOT_FOUND)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error.message));
            }
            return res
                .status(common_1.HttpStatus.BAD_REQUEST)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : "Failed to fetch the opportunity activities"));
        }
    }
    // Fetches the existing mandate details for a given opportunity activity ID.
    async getExistingMandateDetails(opportunityActivityId, res) {
        try {
            const mandate = await this.opportunityService.getExistingMandateDetails(opportunityActivityId);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, "Mandate details retrieved successfully", mandate));
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return res
                    .status(common_1.HttpStatus.NOT_FOUND)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error.message));
            }
            return res
                .status(common_1.HttpStatus.BAD_REQUEST)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : "Failed to fetch mandate details"));
        }
    }
    async getOpportunityActivityMeta(opportunityId, activityId, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const viewValidation = await this.scopeService.validateResourceScope(userId, "opportunity", "edit", opportunityId);
            if (!viewValidation) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.FORBIDDEN, "Access denied: You do not have permission to edit this company.");
            }
            const activityMeta = await this.opportunityService.getOpportunityActivityMeta(opportunityId, activityId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.opportunityActivityMetaRetrieved, activityMeta);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.opportunityActivityMetaNotFound);
            }
        }
    }
    async createOpportunityActivityData(req, activityMeta) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const opportunityActivityData = await this.opportunityService.createOpportunityMeta(userId, activityMeta);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.opportunityActivityCreated, opportunityActivityData);
        }
        catch (error) {
            if (error instanceof common_1.BadRequestException) {
                throw new common_1.BadRequestException(error.getResponse());
            }
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error ? error.message : messages_1.errorMessages.opportunityActivityMetaNotFound);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.opportunityActivityCreationFailed);
        }
    }
    async opportunityActivityApproval(opportunityActivityId, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const activityApproval = await this.opportunityService.opportunityActivityApproval(opportunityActivityId, userId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, "Opportunity Activity Approved successfully.", activityApproval);
        }
        catch (error) {
            if (error instanceof common_1.BadRequestException) {
                throw new common_1.BadRequestException(error.getResponse());
            }
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error ? error.message : "Opportunity Activity not found.");
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : "Failed to update Opportunity Activity.");
        }
    }
    // @updateOpportunityActivitySwaggerMetadata()
    async updateOpportunityActivityData(opportunityActivityId, req, activityMeta) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const updatedActivityData = await this.opportunityService.updateOpportunityMeta(opportunityActivityId, userId, activityMeta);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, "Opportunity Activity updated successfully.", updatedActivityData);
        }
        catch (error) {
            console.error("Error in updateOpportunityActivityData:", error);
            if (error instanceof common_1.BadRequestException) {
                throw new common_1.BadRequestException(error.getResponse());
            }
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error ? error.message : "Opportunity Activity not found.");
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : "Failed to update Opportunity Activity.");
        }
    }
    /**
     * Updates the final negotiation meeting and meeting table entry.
     */
    async updateOpportunityRfpDetailsEntry(opportunityActivityId, updateOpportunityRfpDetailsEntryDto, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const result = await this.opportunityService.updateOpportunityRfpDetailsEntry(opportunityActivityId, updateOpportunityRfpDetailsEntryDto, userId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, "RFP Details Entry updated successfully.", result);
        }
        catch (error) {
            console.error("Error in updateOpportunityRfpDetailsEntry:", error);
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : "Failed to update RFP Details Entry.");
        }
    }
    /**
     * Retrieves the RFP data based on the Opportunity Activity ID.
     */
    async getRfpDataByOpportunityId(opportunityActivityId) {
        try {
            const rfpData = await this.opportunityService.getRfpDataByOpportunityId(opportunityActivityId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.opportunityActivityMetaRetrieved, rfpData);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.opportunityActivityMetaNotFound);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.opportunityActivityMetaNotFound);
        }
    }
    async getOpportunityCoversMeta(opportunityId, activityId) {
        try {
            const coversMeta = await this.opportunityService.getOpportunityCoversMeta(opportunityId, activityId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.opportunityActivityMetaRetrieved, coversMeta);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.opportunityActivityMetaNotFound);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.opportunityActivityMetaNotFound);
        }
    }
    async getOpportunityActivityDataById(opportunityActivityId) {
        try {
            const activityDetails = await this.opportunityService.getOpportunityActivitesDataById(opportunityActivityId);
            if (!activityDetails) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, `opportunity activity ID: ${opportunityActivityId}, not found`);
            }
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.opportunityActivityDataRetrieved, activityDetails);
        }
        catch (error) {
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.opportunityActivitiesRetrieveFailed);
        }
    }
    async updatePolicyDocketById(opportunityActivityId, updatePolicyDocketDto, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const updatedPolicyDocket = await this.opportunityService.updatePolicyDocketByIdActivity(opportunityActivityId, updatePolicyDocketDto, userId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.policyDocketUpdated, updatedPolicyDocket);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.policyDocketNotFound);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.policyDocketUpdateFailed);
        }
    }
    async updateQuote(quoteId, updateQuoteDto, req, res) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const updatedQuoteDetails = await this.opportunityService.updateQuote(quoteId, updateQuoteDto, userId);
            res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.quoteUpdated, updatedQuoteDetails));
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error.message);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error ? error.message : messages_1.errorMessages.quoteUpdateFailed);
        }
    }
    async updateOpportunityQuoteByActivityId(opportunityActivityId, updateQuoteDto, req, res) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const updatedQuoteEntryDetails = await this.opportunityService.updateOpportunityQuoteByActivityId(opportunityActivityId, updateQuoteDto, userId);
            res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.quoteUpdated, updatedQuoteEntryDetails));
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                res
                    .status(common_1.HttpStatus.NOT_FOUND)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error.message));
            }
            res
                .status(common_1.HttpStatus.BAD_REQUEST)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.quoteUpdateFailed));
        }
    }
    async deleteQuoteEntry(quoteId) {
        try {
            await this.opportunityService.softDeleteQuoteEntry(quoteId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.quoteDeleted);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error.message);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.quoteDeletionFailed);
        }
    }
    async getBrokingSlipVersionsByOpportunityActivityId(opportunityId, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const viewValidation = await this.scopeService.validateResourceScope(userId, "opportunity", "edit", opportunityId);
            if (!viewValidation) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.FORBIDDEN, "Access denied: You do not have permission to edit this company.");
            }
            const brokingSlipVersions = await this.opportunityService.getBrokingSlipVersionsByOpportunityId(opportunityId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.opportunityActivityMetaRetrieved, brokingSlipVersions);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.brokingSlipVersionsNotFound, []);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.brokingSlipVersionsNotFound, []);
        }
    }
    async updateHeldCoverNoteById(opportunityActivityId, updateHeldCoverNoteDto, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const updatedHeldCoverNote = await this.opportunityService.updateHeldCoverNoteById(opportunityActivityId, updateHeldCoverNoteDto, userId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.heldCoverNoteUpdated, updatedHeldCoverNote);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.heldCoverNoteNotFound);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.heldCoverNoteUpdateFailed);
        }
    }
    // Fetch broking slip data based on the opportunity activity Id
    async getBrokingSlipByOpportunityActivityId(opportunityActivityId, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const opportunity = await this.opportunityService.getOpportunityIdByOpportunityActivityId(opportunityActivityId);
            const viewValidation = await this.scopeService.validateResourceScope(userId, "opportunity", "view", opportunity.opportunityId);
            if (!viewValidation) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.FORBIDDEN, "Access denied: You do not have permission to edit this company.");
            }
            const brokingSlip = await this.opportunityService.getBrokingSlipVersionDetailsByOpportunityActivityId(opportunityActivityId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.opportunityActivityMetaRetrieved, brokingSlip);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.brokingSlipActivityMetaNotFound);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.brokingSlipActivityMetaNotFound);
        }
    }
    async updatePolicyConfirmationById(opportunityActivityId, updatePolicyConfirmationDto, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const updatedPolicyConfirmation = await this.opportunityService.updatePolicyConfirmationById(opportunityActivityId, updatePolicyConfirmationDto, userId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.policyConfirmationUpdated, updatedPolicyConfirmation);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.policyConfirmationNotFound);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.policyConfirmationUpdateFailed);
        }
    }
    async updateOpportunityLostActivity(opportunityActivityId, req, updateOpportunityLostData) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const data = await this.opportunityService.updateOpportunityLostActivity(opportunityActivityId, updateOpportunityLostData, userId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, "Opportunity lost activity updated successfully.", data);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error.message);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : "Failed to update opportunity lost activity.");
        }
    }
    async getFinalNegotiationActivity(id) {
        try {
            const data = await this.opportunityService.getFinalNegotiationActivity(id);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.finalNegotiationActivityRetrieved, data);
        }
        catch (error) {
            console.error("Error in getFinalNegotiationActivity:", error);
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error.message);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.finalNegotiationActivityRetrievalFailed);
        }
    }
    async getBrokingSlipByVersionId(opportunityId, versionId, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const viewValidation = await this.scopeService.validateResourceScope(userId, "opportunity", "edit", opportunityId);
            if (!viewValidation) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.FORBIDDEN, "Access denied: You do not have permission to edit this company.");
            }
            const brokingSlip = await this.opportunityService.getBrokingSlipVersionDetailsByVersionId(opportunityId, versionId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.opportunityActivityCreated, brokingSlip);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.brokingSlipActivityMetaNotFound);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.brokingSlipActivityMetaNotFound);
        }
    }
    async createBrokingSlipData(opportunityActivityId, req, brokingSlipDetails) {
        try {
            let updatedBrokingSlipVersion = await this.opportunityService.updateBrokingSlipData(brokingSlipDetails.opportunityActivityId, brokingSlipDetails.brokingSlipDetails, brokingSlipDetails.statusLid);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.opportunityActivityUpdatedSuccessfully, updatedBrokingSlipVersion);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.brokingSlipActivityMetaNotFound);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.brokingSlipActivityMetaNotFound);
        }
    }
    async updateBrokingSlipByVersionId(versionId, brokingSlipDetailsDto, req) {
        try {
            let updatedBrokingSlipVersion = await this.opportunityService.updateBrokingSlipVersions(brokingSlipDetailsDto.opportunityActivityId, versionId, brokingSlipDetailsDto.brokingSlipVersionDetails, brokingSlipDetailsDto.statusLid);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.opportunityActivityMetaRetrieved, updatedBrokingSlipVersion);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.brokingSlipActivityMetaNotFound);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.brokingSlipActivityMetaNotFound);
        }
    }
    async deleteBrokingSlipVersionById(opportunityId, versionId, req) {
        try {
            await this.opportunityService.deleteBrokingSlipVersion(opportunityId, versionId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.brokingSlipVersionDeleted, []);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.brokingSlipActivityMetaNotFound);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.brokingSlipActivityMetaNotFound);
        }
    }
    async updatePolicyHardCopyById(opportunityActivityId, updatePolicyHardCopyDto, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const updatedPolicyHardCopy = await this.opportunityService.updatePolicyHardCopyById(opportunityActivityId, updatePolicyHardCopyDto, userId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.policyHardCopyUpdated, updatedPolicyHardCopy);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.policyHardCopyNotFound);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.policyHardCopyUpdateFailed);
        }
    }
    async getQcrBrokingSlipVersionsData(opportunityActivityId) {
        try {
            const qcrBrokingSlipVersionsData = await this.opportunityService.getAllQcrBrokingSlipVersionsData(opportunityActivityId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.brokeingSlipVersionsRetrieved, qcrBrokingSlipVersionsData);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.brokingSlipVersionsNotFound);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.brokingSlipVersionsNotFound);
        }
    }
    async updatePlacementSlip(id, dto, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            dto.updatedBy = userId;
            const result = await this.opportunityService.updatePlacementSlip(id, dto);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.placementSlipUpdated, result);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error.message);
            }
            if (error instanceof common_1.BadRequestException) {
                throw new common_1.BadRequestException(error.getResponse());
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.placementSlipUpdateFailed);
        }
    }
    async softDeletePlacementSlip(id) {
        try {
            await this.opportunityService.softDeletePlacementSlip(id);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.placementSlipDeleted);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error.message);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.placementSlipDeletionFailed);
        }
    }
    async updateQuoteComparisonReportById(opportunityActivityId, updateQuoteComparisonReportDto, req, res) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const updatedQuoteComparisonReport = await this.opportunityService.updateQuoteComparisonReportById(opportunityActivityId, updateQuoteComparisonReportDto, userId);
            res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.quoteComparisonReportUpdated, updatedQuoteComparisonReport));
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                res
                    .status(common_1.HttpStatus.NOT_FOUND)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.quoteComparisonReportNotFound));
            }
            res
                .status(common_1.HttpStatus.BAD_REQUEST)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.quoteComparisonReportUpdateFailed));
        }
    }
    async getOpportunityContacts(opportunityId, res) {
        try {
            const contacts = await this.opportunityService.getOpportunityContacts(opportunityId);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.opportunityContactsRetrieved, contacts));
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return res
                    .status(common_1.HttpStatus.NOT_FOUND)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error.message || messages_1.errorMessages.opportunityContactsNotFound));
            }
            return res
                .status(common_1.HttpStatus.INTERNAL_SERVER_ERROR)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error.message || messages_1.errorMessages.failedToFetchOpportunityContacts));
        }
    }
    async updatePremiumCalculationById(opportunityActivityId, updatePremiumCalculationDto, req, res) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const updatedPremiumCalculation = await this.opportunityService.updatePremiumCalculationActivity(opportunityActivityId, updatePremiumCalculationDto, userId);
            res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.premiumCalculationUpdated, updatedPremiumCalculation));
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                res
                    .status(common_1.HttpStatus.NOT_FOUND)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.premiumCalculationNotFound));
            }
            res
                .status(common_1.HttpStatus.BAD_REQUEST)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : messages_1.errorMessages.premiumCalculationUpdateFailed));
        }
    }
    async generateQuoteComparisonReport(quoteComparisonReportDto, req, res) {
        try {
            // You may want to pass userId if needed for auditing
            const report = await this.opportunityService.generateQuoteComparisonReport(quoteComparisonReportDto);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, "Quote comparison report generated successfully.", report));
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return res
                    .status(common_1.HttpStatus.NOT_FOUND)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error.message || "Quote comparison report not found."));
            }
            res
                .status(common_1.HttpStatus.BAD_REQUEST)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : "Failed to generate quote comparison report."));
        }
    }
    async getPolicyConfirmationCdAccountDetails(opportunityActivityId) {
        try {
            const data = await this.opportunityService.getPolicyConfirmationCdAccountDetails(opportunityActivityId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, "CD account details retrieved successfully", data);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error.message);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                ? error.message
                : "CD account details retrieval failed");
        }
    }
    async getPolicyById(policyId, res) {
        try {
            const policy = await this.opportunityService.getPolicyById(policyId);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, "Policy retrieved successfully", policy));
        }
        catch (error) {
            console.error("Error in getPolicyById:", error);
            return res
                .status(common_1.HttpStatus.BAD_REQUEST)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error ? error.message : "Failed to fetch policy."));
        }
    }
};
exports.OpportunityController = OpportunityController;
tslib_1.__decorate([
    (0, common_1.Post)(),
    (0, opportunity_swagger_1.createOpportunitySwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, common_1.Body)("riskLocations")),
    tslib_1.__param(2, (0, common_1.Body)("claimExperiences")),
    tslib_1.__param(3, (0, common_1.Body)("documents")),
    tslib_1.__param(4, (0, common_1.Body)("previousPlacementDetails")),
    tslib_1.__param(5, (0, common_1.Body)("opportunityPreviousMediatorDetails")),
    tslib_1.__param(6, (0, common_1.Body)("contacts")),
    tslib_1.__param(7, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_c = typeof create_opportunity_dto_1.CreateOpportunityDto !== "undefined" && create_opportunity_dto_1.CreateOpportunityDto) === "function" ? _c : Object, Array, Array, Array, Array, Array, Array, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], OpportunityController.prototype, "createOpportunity", null);
tslib_1.__decorate([
    (0, common_1.Get)(),
    (0, opportunity_swagger_1.getAllOpportunitiesSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Query)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_d = typeof opportunity_query_param_dto_1.GetOpportunityQueryDto !== "undefined" && opportunity_query_param_dto_1.GetOpportunityQueryDto) === "function" ? _d : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", typeof (_e = typeof Promise !== "undefined" && Promise) === "function" ? _e : Object)
], OpportunityController.prototype, "getAllOpportunityList", null);
tslib_1.__decorate([
    (0, common_1.Get)("quote"),
    (0, opportunity_swagger_1.getQuoteByBrokingSlipAndActivitySwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Query)("brokingSlipId")),
    tslib_1.__param(1, (0, common_1.Query)("opportunityActivityId")),
    tslib_1.__param(2, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Object]),
    tslib_1.__metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
], OpportunityController.prototype, "getQuoteByBrokingSlipAndActivity", null);
tslib_1.__decorate([
    (0, common_1.Get)("quote/broking-slip/:brokingSlipId"),
    (0, opportunity_swagger_1.getQuotesByBrokingSlipSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("brokingSlipId", common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
], OpportunityController.prototype, "getQuotesByBrokingSlip", null);
tslib_1.__decorate([
    (0, common_1.Get)("quote/:opportunityActivityId"),
    (0, opportunity_swagger_1.getQuoteEntryDetailsSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("opportunityActivityId", common_1.ParseIntPipe)),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number]),
    tslib_1.__metadata("design:returntype", Promise)
], OpportunityController.prototype, "getQuoteEntryDetails", null);
tslib_1.__decorate([
    (0, common_1.Get)("policies"),
    tslib_1.__param(0, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", typeof (_h = typeof Promise !== "undefined" && Promise) === "function" ? _h : Object)
], OpportunityController.prototype, "getAllPolicies", null);
tslib_1.__decorate([
    (0, common_1.Get)(":opportunityId"),
    (0, opportunity_swagger_1.getOpportunityByIdSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("opportunityId")),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], OpportunityController.prototype, "getOpportunityById", null);
tslib_1.__decorate([
    (0, common_1.Get)("/company/:companyId"),
    tslib_1.__param(0, (0, common_1.Param)("companyId", common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Query)("page")),
    tslib_1.__param(2, (0, common_1.Query)("limit")),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number]),
    tslib_1.__metadata("design:returntype", typeof (_j = typeof Promise !== "undefined" && Promise) === "function" ? _j : Object)
], OpportunityController.prototype, "getOpportunitiesByCompanyId", null);
tslib_1.__decorate([
    (0, common_1.Get)("quotes/:opportunityActivityId"),
    tslib_1.__param(0, (0, common_1.Param)("opportunityActivityId", common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Query)("page")),
    tslib_1.__param(2, (0, common_1.Query)("limit")),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number]),
    tslib_1.__metadata("design:returntype", Promise)
], OpportunityController.prototype, "getQuotesBasedOnOpportunityActivityId", null);
tslib_1.__decorate([
    (0, common_1.Get)("finalised-quote/:quoteId"),
    tslib_1.__param(0, (0, common_1.Param)("quoteId", common_1.ParseIntPipe)),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number]),
    tslib_1.__metadata("design:returntype", typeof (_k = typeof Promise !== "undefined" && Promise) === "function" ? _k : Object)
], OpportunityController.prototype, "getQuoteById", null);
tslib_1.__decorate([
    (0, common_1.Get)("covers-prefill/:opportunityActivityId"),
    tslib_1.__param(0, (0, common_1.Param)("opportunityActivityId", common_1.ParseIntPipe)),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number]),
    tslib_1.__metadata("design:returntype", Promise)
], OpportunityController.prototype, "getCoverDataPrefill", null);
tslib_1.__decorate([
    (0, common_1.Put)("activity"),
    (0, opportunity_swagger_1.updateOpportunityActivitiesSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__param(2, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_l = typeof opportunity_activity_dto_1.OpportunityActivitiesDto !== "undefined" && opportunity_activity_dto_1.OpportunityActivitiesDto) === "function" ? _l : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], OpportunityController.prototype, "updateOpportunityActivity", null);
tslib_1.__decorate([
    (0, common_1.Put)(":opportunityId"),
    (0, opportunity_swagger_1.updateOpportunityByIdSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("opportunityId")),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, common_1.Body)("riskLocations")),
    tslib_1.__param(3, (0, common_1.Body)("claimExperiences")),
    tslib_1.__param(4, (0, common_1.Body)("documents")),
    tslib_1.__param(5, (0, common_1.Body)("previousPlacementDetails")),
    tslib_1.__param(6, (0, common_1.Body)("opportunityPreviousMediatorDetails")),
    tslib_1.__param(7, (0, common_1.Body)("contacts")),
    tslib_1.__param(8, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_m = typeof update_opportunity_dto_1.UpdateOpportunityDto !== "undefined" && update_opportunity_dto_1.UpdateOpportunityDto) === "function" ? _m : Object, Array, Array, Array, Array, Array, Array, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], OpportunityController.prototype, "updateOpportunityById", null);
tslib_1.__decorate([
    (0, common_1.Delete)(":opportunityId"),
    (0, opportunity_swagger_1.deleteOpportunityByIdSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("opportunityId")),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], OpportunityController.prototype, "deleteOpportunityById", null);
tslib_1.__decorate([
    (0, common_1.Get)("activities/:opportunityId"),
    (0, opportunity_swagger_1.getOpportunityActivityByIdSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("opportunityId")),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__param(2, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], OpportunityController.prototype, "getOpportunityActivityById", null);
tslib_1.__decorate([
    (0, common_1.Get)("fetch-existing-mandate/:opportunityActivityId"),
    tslib_1.__param(0, (0, common_1.Param)("opportunityActivityId")),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], OpportunityController.prototype, "getExistingMandateDetails", null);
tslib_1.__decorate([
    (0, common_1.Get)("activity-meta/:opportunityId/:activityId"),
    (0, opportunity_swagger_1.getOpportunityActivityMetaSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("opportunityId", common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Param)("activityId", common_1.ParseIntPipe)),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Object]),
    tslib_1.__metadata("design:returntype", typeof (_o = typeof Promise !== "undefined" && Promise) === "function" ? _o : Object)
], OpportunityController.prototype, "getOpportunityActivityMeta", null);
tslib_1.__decorate([
    (0, common_1.Post)("activity-meta"),
    (0, opportunity_swagger_1.createOpportunityActivitySwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Req)()),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, Object]),
    tslib_1.__metadata("design:returntype", typeof (_p = typeof Promise !== "undefined" && Promise) === "function" ? _p : Object)
], OpportunityController.prototype, "createOpportunityActivityData", null);
tslib_1.__decorate([
    (0, common_1.Put)(":opportunityActivityId/activity-approval"),
    tslib_1.__param(0, (0, common_1.Param)("opportunityActivityId", common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], OpportunityController.prototype, "opportunityActivityApproval", null);
tslib_1.__decorate([
    (0, common_1.Put)("activity-meta/:opportunityActivityId")
    // @updateOpportunityActivitySwaggerMetadata()
    ,
    tslib_1.__param(0, (0, common_1.Param)("opportunityActivityId", common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__param(2, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object, Object]),
    tslib_1.__metadata("design:returntype", typeof (_q = typeof Promise !== "undefined" && Promise) === "function" ? _q : Object)
], OpportunityController.prototype, "updateOpportunityActivityData", null);
tslib_1.__decorate([
    (0, common_1.Put)("rfp-details-entry/:opportunityActivityId"),
    tslib_1.__param(0, (0, common_1.Param)("opportunityActivityId", common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_r = typeof opportunity_rfp_details_entry_dto_1.UpdateRfpDetailsEntryDto !== "undefined" && opportunity_rfp_details_entry_dto_1.UpdateRfpDetailsEntryDto) === "function" ? _r : Object, Object]),
    tslib_1.__metadata("design:returntype", typeof (_s = typeof Promise !== "undefined" && Promise) === "function" ? _s : Object)
], OpportunityController.prototype, "updateOpportunityRfpDetailsEntry", null);
tslib_1.__decorate([
    (0, common_1.Get)("activities/rfpData/:opportunityActivityId"),
    (0, opportunity_swagger_1.getRfpDataByOpportunityIdSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("opportunityActivityId", common_1.ParseIntPipe)),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number]),
    tslib_1.__metadata("design:returntype", typeof (_t = typeof Promise !== "undefined" && Promise) === "function" ? _t : Object)
], OpportunityController.prototype, "getRfpDataByOpportunityId", null);
tslib_1.__decorate([
    (0, common_1.Get)("activities/coversMeta/:opportunityId"),
    (0, opportunity_swagger_1.getOpportunityCoversMetaSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("opportunityId")),
    tslib_1.__param(1, (0, common_1.Query)("activityId")),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Number]),
    tslib_1.__metadata("design:returntype", typeof (_u = typeof Promise !== "undefined" && Promise) === "function" ? _u : Object)
], OpportunityController.prototype, "getOpportunityCoversMeta", null);
tslib_1.__decorate([
    (0, common_1.Get)("activity-data/:opportunityActivityId"),
    (0, opportunity_swagger_1.getOpportunityActivitySwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("opportunityActivityId", common_1.ParseIntPipe)),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number]),
    tslib_1.__metadata("design:returntype", typeof (_v = typeof Promise !== "undefined" && Promise) === "function" ? _v : Object)
], OpportunityController.prototype, "getOpportunityActivityDataById", null);
tslib_1.__decorate([
    (0, common_1.Put)("policy-docket/:opportunityActivityId"),
    (0, opportunity_swagger_1.updatePolicyDocketByIdSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("opportunityActivityId", common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_w = typeof update_policy_docket_1.UpdatePolicyDocketDto !== "undefined" && update_policy_docket_1.UpdatePolicyDocketDto) === "function" ? _w : Object, Object]),
    tslib_1.__metadata("design:returntype", typeof (_x = typeof Promise !== "undefined" && Promise) === "function" ? _x : Object)
], OpportunityController.prototype, "updatePolicyDocketById", null);
tslib_1.__decorate([
    (0, common_1.Put)("quote/:quoteId"),
    (0, opportunity_swagger_1.updateQuoteSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("quoteId", common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__param(3, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_y = typeof create_quote_entry_dto_1.CreateQuoteDto !== "undefined" && create_quote_entry_dto_1.CreateQuoteDto) === "function" ? _y : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", typeof (_z = typeof Promise !== "undefined" && Promise) === "function" ? _z : Object)
], OpportunityController.prototype, "updateQuote", null);
tslib_1.__decorate([
    (0, common_1.Put)("quote/activity/:opportunityActivityId"),
    (0, opportunity_swagger_1.updateOpportunityQuoteByActivityIdSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("opportunityActivityId", common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__param(3, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_0 = typeof create_quote_entry_dto_1.UpdateQuoteDto !== "undefined" && create_quote_entry_dto_1.UpdateQuoteDto) === "function" ? _0 : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", typeof (_1 = typeof Promise !== "undefined" && Promise) === "function" ? _1 : Object)
], OpportunityController.prototype, "updateOpportunityQuoteByActivityId", null);
tslib_1.__decorate([
    (0, common_1.Delete)("quote/:quoteId"),
    tslib_1.__param(0, (0, common_1.Param)("quoteId", common_1.ParseIntPipe)),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number]),
    tslib_1.__metadata("design:returntype", Promise)
], OpportunityController.prototype, "deleteQuoteEntry", null);
tslib_1.__decorate([
    (0, common_1.Get)("activities/broking-slip/versions/:opportunityId"),
    tslib_1.__param(0, (0, common_1.Param)("opportunityId", common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], OpportunityController.prototype, "getBrokingSlipVersionsByOpportunityActivityId", null);
tslib_1.__decorate([
    (0, common_1.Put)("held-cover-note/:opportunityActivityId"),
    (0, opportunity_swagger_1.updateHeldCoverNoteByIdSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("opportunityActivityId", common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_2 = typeof update_held_cover_note_dto_1.UpdateHeldCoverNoteDto !== "undefined" && update_held_cover_note_dto_1.UpdateHeldCoverNoteDto) === "function" ? _2 : Object, Object]),
    tslib_1.__metadata("design:returntype", typeof (_3 = typeof Promise !== "undefined" && Promise) === "function" ? _3 : Object)
], OpportunityController.prototype, "updateHeldCoverNoteById", null);
tslib_1.__decorate([
    (0, common_1.Get)("activities/broking-slip/:opportunityActivityId"),
    tslib_1.__param(0, (0, common_1.Param)("opportunityActivityId", common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], OpportunityController.prototype, "getBrokingSlipByOpportunityActivityId", null);
tslib_1.__decorate([
    (0, common_1.Put)("policy-confirmation/:opportunityActivityId"),
    (0, opportunity_swagger_1.updatePolicyConfirmationByIdSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("opportunityActivityId", common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_4 = typeof update_policy_confirmation_dto_1.UpdatePolicyConfirmationDto !== "undefined" && update_policy_confirmation_dto_1.UpdatePolicyConfirmationDto) === "function" ? _4 : Object, Object]),
    tslib_1.__metadata("design:returntype", typeof (_5 = typeof Promise !== "undefined" && Promise) === "function" ? _5 : Object)
], OpportunityController.prototype, "updatePolicyConfirmationById", null);
tslib_1.__decorate([
    (0, common_1.Put)("opportunity-lost/:opportunityActivityId"),
    tslib_1.__param(0, (0, common_1.Param)("opportunityActivityId", common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__param(2, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object, typeof (_6 = typeof create_opportunity_lost_dto_1.UpdateOpportunityLostDto !== "undefined" && create_opportunity_lost_dto_1.UpdateOpportunityLostDto) === "function" ? _6 : Object]),
    tslib_1.__metadata("design:returntype", Promise)
], OpportunityController.prototype, "updateOpportunityLostActivity", null);
tslib_1.__decorate([
    (0, common_1.Get)("final-negotiation/:id"),
    (0, opportunity_swagger_1.getFinalNegotiationActivitySwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("id", common_1.ParseIntPipe)),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number]),
    tslib_1.__metadata("design:returntype", Promise)
], OpportunityController.prototype, "getFinalNegotiationActivity", null);
tslib_1.__decorate([
    (0, common_1.Get)("activities/broking-slip/:opportunityId/:versionId"),
    tslib_1.__param(0, (0, common_1.Param)("opportunityId", common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Param)("versionId", common_1.ParseIntPipe)),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], OpportunityController.prototype, "getBrokingSlipByVersionId", null);
tslib_1.__decorate([
    (0, common_1.Put)("activities/broking-slip/:opportunityActivityId"),
    (0, opportunity_swagger_1.createOpportunityActivitySwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("opportunityActivityId", common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__param(2, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object, typeof (_7 = typeof create_broking_slip_version_dto_1.CreateBrokingSlipDto !== "undefined" && create_broking_slip_version_dto_1.CreateBrokingSlipDto) === "function" ? _7 : Object]),
    tslib_1.__metadata("design:returntype", typeof (_8 = typeof Promise !== "undefined" && Promise) === "function" ? _8 : Object)
], OpportunityController.prototype, "createBrokingSlipData", null);
tslib_1.__decorate([
    (0, common_1.Put)("activities/broking-slip/version/:versionId"),
    tslib_1.__param(0, (0, common_1.Param)("versionId", common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_9 = typeof create_broking_slip_version_dto_1.CreateBrokingSlipVersionDto !== "undefined" && create_broking_slip_version_dto_1.CreateBrokingSlipVersionDto) === "function" ? _9 : Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], OpportunityController.prototype, "updateBrokingSlipByVersionId", null);
tslib_1.__decorate([
    (0, common_1.Delete)("activities/broking-slip/:opportunityId/:versionId"),
    tslib_1.__param(0, (0, common_1.Param)("opportunityId", common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Param)("versionId", common_1.ParseIntPipe)),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], OpportunityController.prototype, "deleteBrokingSlipVersionById", null);
tslib_1.__decorate([
    (0, common_1.Put)("policy-hard-copy/:opportunityActivityId"),
    (0, opportunity_swagger_1.updatePolicyHardCopyByIdSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("opportunityActivityId", common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_10 = typeof update_policy_hard_copy_dto_1.UpdatePolicyHardCopyDto !== "undefined" && update_policy_hard_copy_dto_1.UpdatePolicyHardCopyDto) === "function" ? _10 : Object, Object]),
    tslib_1.__metadata("design:returntype", typeof (_11 = typeof Promise !== "undefined" && Promise) === "function" ? _11 : Object)
], OpportunityController.prototype, "updatePolicyHardCopyById", null);
tslib_1.__decorate([
    (0, common_1.Get)("qcr_versions/:opportunityActivityId"),
    (0, opportunity_swagger_1.getAllBrokingSlipVersionsSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("opportunityActivityId")),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number]),
    tslib_1.__metadata("design:returntype", typeof (_12 = typeof Promise !== "undefined" && Promise) === "function" ? _12 : Object)
], OpportunityController.prototype, "getQcrBrokingSlipVersionsData", null);
tslib_1.__decorate([
    (0, common_1.Put)("placement-slip/:id"),
    (0, opportunity_swagger_1.updatePlacementSlipSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("id", common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_13 = typeof update_placement_slip_dto_1.UpdatePlacementSlipDto !== "undefined" && update_placement_slip_dto_1.UpdatePlacementSlipDto) === "function" ? _13 : Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], OpportunityController.prototype, "updatePlacementSlip", null);
tslib_1.__decorate([
    (0, common_1.Delete)("placement-slip/:id"),
    (0, opportunity_swagger_1.deletePlacementSlipSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("id", common_1.ParseIntPipe)),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number]),
    tslib_1.__metadata("design:returntype", Promise)
], OpportunityController.prototype, "softDeletePlacementSlip", null);
tslib_1.__decorate([
    (0, common_1.Put)("quote-comparison-report/:id"),
    (0, opportunity_swagger_1.updateQuoteComparisonReportByIdSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("opportunityActivityId", common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__param(3, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_14 = typeof update_quote_comparison_report_dto_1.UpdateQuoteComparisonReportDto !== "undefined" && update_quote_comparison_report_dto_1.UpdateQuoteComparisonReportDto) === "function" ? _14 : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", typeof (_15 = typeof Promise !== "undefined" && Promise) === "function" ? _15 : Object)
], OpportunityController.prototype, "updateQuoteComparisonReportById", null);
tslib_1.__decorate([
    (0, common_1.Get)(":opportunityId/contacts"),
    (0, opportunity_swagger_1.getOpportunityContactsSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("opportunityId", common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", typeof (_16 = typeof Promise !== "undefined" && Promise) === "function" ? _16 : Object)
], OpportunityController.prototype, "getOpportunityContacts", null);
tslib_1.__decorate([
    (0, common_1.Put)("premium-calculation/:opportunityActivityId"),
    tslib_1.__param(0, (0, common_1.Param)("opportunityActivityId", common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__param(3, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_17 = typeof update_premium_calculation_dto_1.UpdatePremiumCalculationDto !== "undefined" && update_premium_calculation_dto_1.UpdatePremiumCalculationDto) === "function" ? _17 : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", typeof (_18 = typeof Promise !== "undefined" && Promise) === "function" ? _18 : Object)
], OpportunityController.prototype, "updatePremiumCalculationById", null);
tslib_1.__decorate([
    (0, common_1.Post)("report-generation"),
    (0, opportunity_swagger_1.generateQuoteComparisonReportSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__param(2, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_19 = typeof generate_quote_comparison_report_dto_1.QuoteComparisonReportDto !== "undefined" && generate_quote_comparison_report_dto_1.QuoteComparisonReportDto) === "function" ? _19 : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", typeof (_20 = typeof Promise !== "undefined" && Promise) === "function" ? _20 : Object)
], OpportunityController.prototype, "generateQuoteComparisonReport", null);
tslib_1.__decorate([
    (0, common_1.Get)("policy-confirmation-account-details/:opportunityActivityId"),
    (0, opportunity_swagger_1.getPolicyConfirmationCdAccountDetailsSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("opportunityActivityId", common_1.ParseIntPipe)),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number]),
    tslib_1.__metadata("design:returntype", Promise)
], OpportunityController.prototype, "getPolicyConfirmationCdAccountDetails", null);
tslib_1.__decorate([
    (0, common_1.Get)("policy/:policyId"),
    tslib_1.__param(0, (0, common_1.Param)("policyId", common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", typeof (_21 = typeof Promise !== "undefined" && Promise) === "function" ? _21 : Object)
], OpportunityController.prototype, "getPolicyById", null);
exports.OpportunityController = OpportunityController = tslib_1.__decorate([
    (0, common_1.Controller)("opportunity"),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof opportunity_service_1.OpportunityService !== "undefined" && opportunity_service_1.OpportunityService) === "function" ? _a : Object, typeof (_b = typeof scope_utils_1.ScopeService !== "undefined" && scope_utils_1.ScopeService) === "function" ? _b : Object])
], OpportunityController);
